module.exports = __webpack_public_path__ + "img/19.fe78bc4.png";